/**
 * The CSS value for disabled cursors.
 * @public
 */
export const disabledCursor = "not-allowed";
